import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from 'app/app';
import version from 'version';

// Exposes the running build's version on a namespaced global so the deployed bundle can report
// which build it is. src/version.js is imported nowhere else, so webpack tree-shakes it out of
// the bundle if this line is removed — silently making the version unreachable from the artifact.
window.__BLOBHUB_VERSION__ = version;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
